<template>
    <Link :href="'/song/' + song.id" class="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-nomad-accent rounded-2xl">
        <!-- Newest release gets a hero row -->
        <div v-if="jumbo"
            class="relative flex flex-col gap-5 overflow-hidden rounded-3xl p-5 ring-1 ring-inset ring-nomad-accent/25 sm:flex-row sm:items-center sm:p-6"
            style="background: linear-gradient(120deg, rgba(174, 226, 0, 0.14), rgba(174, 226, 0, 0.02) 60%);">
            <img :src="song.cover" :alt="song.name"
                class="aspect-square w-full rounded-2xl object-cover shadow-lift ring-1 ring-white/10 sm:w-40" />
            <div class="min-w-0 flex-1">
                <p class="nl-eyebrow">Newest release</p>
                <h3 class="mt-2 truncate font-display text-2xl font-bold tracking-tight text-white md:text-3xl">
                    {{ song.name }}
                </h3>
                <h4 class="mt-1 truncate text-nomad-200">{{ song.artist.name }}</h4>
                <Featuring :artists="song.featuring" class="mt-1" />
                <div class="mt-5 flex items-center gap-2">
                    <button type="button" @click.prevent.stop="prepareCurrent({ id: song.id, type: 'SONG', name: song.name || song.title })"
                        class="nl-btn-primary" aria-label="play song">
                        <span class="icon-play"></span> Play
                    </button>
                    <button type="button" @click.prevent.stop="toggleFavorite(song)" class="nl-btn-icon"
                        :class="isLiked(song) ? '!text-nomad-accent' : ''" :aria-pressed="isLiked(song)" aria-label="add to favorites">
                        <span class="icon-heart"></span>
                    </button>
                </div>
            </div>
        </div>

        <div v-else class="flex items-center gap-4 rounded-2xl p-2 pr-3 transition-colors duration-200 hover:bg-white/[0.05]">
            <div class="relative h-14 w-14 shrink-0 overflow-hidden rounded-xl ring-1 ring-white/[0.08] sm:h-16 sm:w-16">
                <img :src="song.cover" :alt="song.name" loading="lazy" class="h-full w-full object-cover" />
            </div>
            <div class="min-w-0 flex-1">
                <h3 class="truncate text-[0.9375rem] font-semibold text-white transition-colors group-hover:text-nomad-accent">
                    {{ song.name }}
                </h3>
                <h4 class="truncate text-sm text-nomad-300">{{ song.artist.name }}</h4>
                <Featuring :artists="song.featuring" />
            </div>
            <div class="flex shrink-0 items-center gap-1">
                <button type="button" @click.prevent.stop="toggleFavorite(song)"
                    class="flex h-10 w-10 items-center justify-center rounded-full text-lg transition-colors hover:bg-white/[0.06]"
                    :class="isLiked(song) ? 'text-nomad-accent' : 'text-nomad-400 hover:text-nomad-accent'"
                    :aria-pressed="isLiked(song)" aria-label="add to favorites"><span class="icon-heart"></span></button>
                <button type="button" @click.prevent.stop="prepareCurrent({ id: song.id, type: 'SONG', name: song.name || song.title })"
                    class="nl-play-fab h-10 w-10 text-sm" aria-label="play song">
                    <span class="icon-play translate-x-px"></span>
                </button>
            </div>
        </div>
    </Link>
</template>
<script setup>
defineProps({ song: Object, jumbo: Boolean });
</script>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Link } from "@inertiajs/vue3";
import Featuring from "@/components/Featuring.vue";
export default {
    components: {
        Link,
        Featuring,
    },
    computed: mapGetters("favorites", ["isLiked"]),
    methods: {
        ...mapActions("favorites", ["toggleFavorite"]),
        ...mapActions("current", ["prepareCurrent"]),
    },
};
</script>
